// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"8b946ded","679":"ab748cae","907":"31c6cc84"}[chunkId] + ".chunk.css";
};